import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=57c2c576&"
import script from "./terms-and-conditions.vue?vue&type=script&lang=ts&"
export * from "./terms-and-conditions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports